const codigosPostales = [
  { cp: 'AD', provincia: 'Andorra', canShip: true  },
  { cp: '01', provincia: 'Álava', canShip: true },
  { cp: '02', provincia: 'Albacete', canShip: true },
  { cp: '03', provincia: 'Alicante', canShip: true },
  { cp: '04', provincia: 'Almería', canShip: true },
  { cp: '05', provincia: 'Ávila', canShip: true },
  { cp: '06', provincia: 'Badajoz', canShip: true },
  { cp: '07', provincia: 'Illes Balears', canShip: true },
  { cp: '08', provincia: 'Barcelona', canShip: true },
  { cp: '09', provincia: 'Burgos', canShip: true },
  { cp: '10', provincia: 'Cáceres', canShip: true },
  { cp: '11', provincia: 'Cádiz', canShip: true },
  { cp: '12', provincia: 'Castellón', canShip: true },
  { cp: '13', provincia: 'Ciudad Real', canShip: true },
  { cp: '14', provincia: 'Córdoba', canShip: true },
  { cp: '15', provincia: 'A Coruña', canShip: true },
  { cp: '16', provincia: 'Cuenca', canShip: true },
  { cp: '17', provincia: 'Girona', canShip: true },
  { cp: '18', provincia: 'Granada', canShip: true },
  { cp: '19', provincia: 'Guadalajara', canShip: true },
  { cp: '20', provincia: 'Gipuzkoa', canShip: true },
  { cp: '21', provincia: 'Huelva', canShip: true },
  { cp: '22', provincia: 'Huesca', canShip: true },
  { cp: '23', provincia: 'Jaén', canShip: true },
  { cp: '24', provincia: 'León', canShip: true },
  { cp: '25', provincia: 'Lleida', canShip: true },
  { cp: '26', provincia: 'La Rioja', canShip: true },
  { cp: '27', provincia: 'Lugo', canShip: true },
  { cp: '28', provincia: 'Madrid', canShip: true },
  { cp: '29', provincia: 'Málaga', canShip: true },
  { cp: '30', provincia: 'Murcia', canShip: true },
  { cp: '31', provincia: 'Navarra', canShip: true },
  { cp: '32', provincia: 'Ourense', canShip: true },
  { cp: '33', provincia: 'Asturias', canShip: true },
  { cp: '34', provincia: 'Palencia', canShip: true },
  { cp: '35', provincia: 'Las Palmas', canShip: true },
  { cp: '36', provincia: 'Pontevedra', canShip: true },
  { cp: '37', provincia: 'Salamanca', canShip: true },
  { cp: '38', provincia: 'Santa Cruz de Tenerife', canShip: true },
  { cp: '39', provincia: 'Cantabria', canShip: true },
  { cp: '40', provincia: 'Segovia', canShip: true },
  { cp: '41', provincia: 'Sevilla', canShip: true },
  { cp: '42', provincia: 'Soria', canShip: true },
  { cp: '43', provincia: 'Tarragona', canShip: true },
  { cp: '44', provincia: 'Teruel', canShip: true },
  { cp: '45', provincia: 'Toledo', canShip: true },
  { cp: '46', provincia: 'Valencia', canShip: true },
  { cp: '47', provincia: 'Valladolid', canShip: true },
  { cp: '48', provincia: 'Bizkaia', canShip: true },
  { cp: '49', provincia: 'Zamora', canShip: true },
  { cp: '50', provincia: 'Zaragoza', canShip: true },
  { cp: '51', provincia: 'Ceuta', canShip: true },
  { cp: '52', provincia: 'Melilla', canShip: true },
]

export default codigosPostales
